<div class="btn-expand-collapse" [ngClass]='{ "sideCollapse": !isExpandedV }' (click)='toggleV()'>
  <span *ngIf="!isExpandedV" class="pull-right fixedHeight fa fa-chevron-right" style="padding-right: 5px;"></span>
  <span *ngIf="isExpandedV" class="pull-right fixedHeight fa fa-chevron-left" style="padding-right: 5px;"></span>
</div>
<nav class='navbar-primary' [ngClass]='{ "sideCollapse": !isExpandedV, "navbar-development": app_environment=="Development", "navbar-qa": app_environment=="QA" }'>  
  <ul class='navbar-primary-menu'>
    <li>
      <ul *ngIf="menuLinks.length !== 0" id="main-menu" class="nav nabvar-nav">        
        <li *ngFor="let link of menuLinks">
          <a *ngIf="!link.badge"
             [routerLink]="link.path"
             [routerLinkActive]="!link.path ? '' : 'active'"
             (click)='toggle(link)'>
            <i *ngIf="link.icon"
               [ngClass]="link.icon">
            </i>
            <span>{{ link.title }}</span>            
          </a>
          <a *ngIf="link.badge"
             [routerLink]="[]"
             [routerLinkActive]="!link.path ? '' : 'active'"
             (click)='toggle(link)'>
            <i *ngIf="link.icon"
               [ngClass]="link.icon">
            </i>
            <span>{{ link.title }}</span>
            <span *ngIf="link.active"
                  class="pull-right fa fa-chevron-right">
            </span>
            <span *ngIf="!link.active"
                  class="pull-right fa fa-chevron-down">
            </span>
          </a>
          <ul *ngIf="link.children"
              class="nav nav-second-level"
              [ngClass]="{ 'inactive' : link.active }">
            <li *ngFor="let second of link.children">
              <a [routerLink]="second.path"
                 routerLinkActive="active">
                {{ second.title }}
              </a>
              <ul *ngIf="second.children"
                  class="nav nav-third-level">
                <li *ngFor="let third of second.children">
                  <a [routerLink]="third.path"
                     routerLinkActive="active">
                    {{ third.title }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
  <div id="footer">
  <span class="app-version">
    Version: {{app_version}}
    <br />
    Environment: {{app_environment}}
  </span>
</div>
</nav>


<!--<nav id="sidebar">
  <div id="sidebar-header">
    <h3>Bootstrap Header</h3>
  </div>
  <ul class="list-unstyled components">
    <p>Dummy Heading</p>
    <li class="active">
      <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Home</a>
      <ul class="collapse list-unstyled" id="homeSubmenu">
        <li>
          <a href="#">Home 1</a>
        </li>
        <li>
          <a href="#">Home 2</a>
        </li>
        <li>
          <a href="#">Home 3</a>
        </li>
      </ul>
    </li>
    <li>
      <a href="#">About</a>
    </li>
    <li>
      <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">Pages</a>
      <ul class="collapse list-unstyled" id="pageSubmenu">
        <li>
          <a href="#">Page 1</a>
        </li>
        <li>
          <a href="#">Page 2</a>
        </li>
        <li>
          <a href="#">Page 3</a>
        </li>
      </ul>
    </li>
    <li>
      <a href="#">Portfolio</a>
    </li>
    <li>
      <a href="#">Contact</a>
    </li>
  </ul>
</nav>-->

